import React from "react";
import { Box, Container, Grid, Typography, Card, CardContent, Stack, Divider } from "@mui/material";
import { Phone, Email, LocationOn } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useCompany } from "../hooks/useCompany";

const Contact: React.FC = () => {
  const { t } = useTranslation();
  const company = useCompany();

  return (
    <Box sx={{ bgcolor: "#fafafa" }}>
      <Box sx={{ bgcolor: "white", borderBottom: "1px solid #e0e0e0" }}>
        <Container maxWidth="lg" sx={{ py: { xs: 6, md: 8 } }}>
          <Typography
            variant="h3"
            sx={{
              fontWeight: 700,
              color: "#1a1a1a",
              mb: 2,
              textAlign: "center",
            }}
          >
            {t("contact.title")}
          </Typography>
          <Typography
            variant="h6"
            color="text.secondary"
            sx={{
              textAlign: "center",
              fontWeight: 400,
              maxWidth: 640,
              mx: "auto",
            }}
          >
            {t("contact.subtitle")}
          </Typography>
        </Container>
      </Box>

      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={8}>
            <Card
              sx={{
                bgcolor: "white",
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                boxShadow: "none",
                overflow: "hidden",
              }}
            >
              <CardContent sx={{ p: 0 }}>
                <Box
                  component="iframe"
                  src="https://www.google.com/maps?q=Ak%C3%A7e%C5%9Fme%20Mahallesi%2C%202020%2F1.%20Sk.%20No%3A27%2C%2020020%20Merkezefendi%2FDenizli&output=embed"
                  sx={{
                    border: 0,
                    width: "100%",
                    height: { xs: 320, md: 420 },
                  }}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Yanmaz Kapı Harita"
                />
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={4}>
            <Card
              sx={{
                bgcolor: "white",
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                boxShadow: "none",
                height: "fit-content",
              }}
            >
              <CardContent sx={{ p: 4 }}>
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                  {t("footer.contact")}
                </Typography>
                <Stack spacing={2}>
                  <Box>
                    <Stack direction="row" spacing={2} alignItems="center">
                      <Phone sx={{ color: "#d32f2f" }} />
                      <Box>
                        <Typography variant="caption" color="text.secondary">
                          {t("contact.info.phone")}
                        </Typography>
                        <Typography variant="body1" sx={{ fontWeight: 600 }}>
                          {company?.phone || "+90 552 837 83 77"}
                        </Typography>
                      </Box>
                    </Stack>
                  </Box>
                  <Divider />
                  <Box>
                    <Stack direction="row" spacing={2} alignItems="center">
                      <Email sx={{ color: "#d32f2f" }} />
                      <Box>
                        <Typography variant="caption" color="text.secondary">
                          {t("contact.info.email")}
                        </Typography>
                        <Typography variant="body1" sx={{ fontWeight: 600 }}>
                          {company?.email || "info@yanmazkapi.com"}
                        </Typography>
                      </Box>
                    </Stack>
                  </Box>
                  <Divider />
                  <Box>
                    <Stack direction="row" spacing={2} alignItems="flex-start">
                      <LocationOn sx={{ color: "#d32f2f", mt: 0.5 }} />
                      <Box>
                        <Typography variant="caption" color="text.secondary">
                          {t("contact.info.address")}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          {company?.address?.line1 ||
                            t("contact.info.addressLine1")}
                          <br />
                          {company?.address?.line2 ||
                            t("contact.info.addressLine2")}
                        </Typography>
                      </Box>
                    </Stack>
                  </Box>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>

    </Box>
  );
};

export default Contact;
